import React, { ReactElement } from "react";

import "./LoginDialog.css";
import { Button } from "react-bulma-components";

export interface LoginDialogProps {
  signIn: (provider: string) => void;
  signOut: () => void;
}

export function LoginDialog({
  signIn,
  signOut,
}: LoginDialogProps): ReactElement | null {
  const [provider, setProvider] = React.useState("kao");

  return (
    <div className="login-dialog-card">
      <div className="card">
        <header className="card-header">
          <p className="card-header-title">Enter your provider</p>
        </header>
        <div className="card-content control">
          <input
            className="input"
            type="text"
            defaultValue="kao"
            onChange={(event) => {
              setProvider(event.target.value);
            }}
            placeholder="your provider name"
          />
        </div>
        <footer className="card-footer">
          <div className="control">
            <Button color="primary" onClick={() => signIn(provider)}>
              Log in
            </Button>
            <Button onClick={() => signOut()}>Log out</Button>
          </div>
        </footer>
      </div>
    </div>
  );
}
